<template>
  <div class="repairTrace-details repairPage-container">
    <div class="repairTrace-details-header">
      <el-button type="text" icon="el-icon-back" @click="$router.back()"
        >返回</el-button
      >
    </div>
    <div class="repairTrace-details-main">
      <div class="repairTrace-details-main-item">
        <el-row class="repairTrace-details-main-row">
          <el-col :span="8" class="repairTrace-details-main-left">
            <p class="font-format-normal">单号</p>
          </el-col>
          <el-col :span="14">
            <p class="font-format-medium">{{ repairDetails.code }}</p>
          </el-col>
        </el-row>
        <el-row class="repairTrace-details-main-row">
          <el-col :span="8" class="repairTrace-details-main-left">
            <p class="font-format-normal">客户姓名</p>
          </el-col>
          <el-col :span="14">
            <p class="font-format-medium">{{ repairDetails.customer }}</p>
          </el-col>
        </el-row>
        <el-row class="repairTrace-details-main-row">
          <el-col :span="8" class="repairTrace-details-main-left">
            <p class="font-format-normal">快递公司</p>
          </el-col>
          <el-col :span="14" v-if="repairDetails.receiveDeliveryInc">
            <p class="font-format-medium">
              {{ filterExpress(repairDetails.receiveDeliveryInc) }}
            </p>
          </el-col>
        </el-row>
        <el-row class="repairTrace-details-main-row">
          <el-col :span="8" class="repairTrace-details-main-left">
            <p class="font-format-normal">快递单号</p>
          </el-col>
          <el-col :span="14">
            <p class="font-format-medium">
              {{ repairDetails.receiveDeliveryCode }}
            </p>
          </el-col>
        </el-row>
        <!-- <el-row class="repairTrace-details-main-row">
          <el-col :span="8" class="repairTrace-details-main-left">
            <p class="font-format-normal">故障描述</p>
          </el-col>
          <el-col :span="14">
            <p class="font-format-medium">
              {{ repairDetails.desc }}
            </p>
          </el-col>
        </el-row> -->
      </div>
      <div class="repairTrace-details-main-item">
        <el-row class="repairTrace-details-main-row">
          <el-col :span="8" class="repairTrace-details-main-left">
            <p class="font-format-normal">回寄人</p>
          </el-col>
          <el-col :span="14">
            <p class="font-format-medium">
              {{ repairDetails.sendContact }}
            </p>
          </el-col>
        </el-row>
        <el-row class="repairTrace-details-main-row">
          <el-col :span="8" class="repairTrace-details-main-left">
            <p class="font-format-normal">回寄手机</p>
          </el-col>
          <el-col :span="14">
            <p class="font-format-medium">
              {{ repairDetails.sendPhone }}
            </p>
          </el-col>
        </el-row>
        <el-row class="repairTrace-details-main-row">
          <el-col :span="8" class="repairTrace-details-main-left">
            <p class="font-format-normal">回寄地址</p>
          </el-col>
          <el-col :span="14">
            <p class="font-format-medium">
              {{ repairDetails.sendAddress }}
            </p>
          </el-col>
        </el-row>
        <el-row class="repairTrace-details-main-row">
          <el-col :span="8" class="repairTrace-details-main-left">
            <p class="font-format-normal">回寄单号(文石寄出)</p>
          </el-col>
          <el-col :span="14">
            <p class="font-format-medium">
              {{
                repairDetails.sendDeliveryCode && repairDetails.pStatus === 10
                  ? repairDetails.sendDeliveryCode
                  : "暂无"
              }}
            </p>
          </el-col>
        </el-row>
      </div>
      <div class="repairTrace-details-main-item">
        <el-row class="repairTrace-details-main-row">
          <el-col
            :xl="8"
            :lg="8"
            :md="8"
            :sm="24"
            class="repairTrace-details-main-left"
          >
            <p class="font-format-normal">设备</p>
          </el-col>
          <el-col
            :xl="14"
            :lg="14"
            :md="14"
            :sm="24"
            class="repairTrace-details-main-right"
          >
            <div
              class="repairTrace-details-main-rowItem"
              v-for="device in repairDetails.details"
              :key="device.id"
            >
              <div class="repairTrace-details-main-rowItem-top">
                <div class="repairTrace-details-main-rowItem-left">
                  <p class="font-format-medium">型号：{{ device.model }}</p>
                  <p class="font-format-medium">
                    配件：{{
                      device.fittingsData.map((item) => item.name).join("/")
                    }}
                  </p>
                  <p
                    v-if="
                      device.repair &&
                      device.repair.bill &&
                      device.payStatus !== 0
                    "
                    class="font-format-medium"
                  >
                    应付金额：{{ device.repair.bill.actualAmount }}
                  </p>
                  <p class="font-format-medium">描述：{{ device.desc }}</p>
                </div>
                <!-- <PayPal :orderData="getOrderData(device)" /> -->
                <el-button
                  v-if="device.payStatus === 1"
                  type="primary"
                  @click="pay(device)"
                  >支付</el-button
                >
                <!-- <el-button
                  v-else-if="device.payStatus === 2"
                  disabled
                  type="primary"
                  >已付费</el-button
                > -->
              </div>
              <div
                class="repairTrace-details-main-rowItem-bottom"
                v-if="device.repair && device.repair.attachs.length"
              >
                <p class="font-format-medium">维修附件：</p>
                <div
                  class="repairTrace-details-repair-attachs"
                  v-for="item in device.repair.attachs"
                  :key="item.id"
                >
                  <el-link type="primary" @click="getOssAttachsUrl(item)">{{
                    item.name
                  }}</el-link>
                  <p v-if="item.desc" class="font-format-medium">
                    附件描述：{{ item.desc }}
                  </p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="repairTrace-details-main-item">
        <el-row class="repairTrace-details-main-row">
          <el-col :span="8" class="repairTrace-details-main-left">
            <p class="font-format-normal">进度</p>
          </el-col>
          <el-col :span="14" class="repairTrace-details-main-right">
            <div class="repairTrace-details-steps">
              <div
                class="repairTrace-details-steps-item"
                v-for="(item, index) in repairDetails.progress"
                :key="item.id"
              >
                <!-- <div class="repairTrace-details-steps-item-left">
                  <i
                    v-if="index + 1 > current"
                    class="el-icon-circle-check"
                  ></i>
                  <div
                    v-else-if="index + 1 === current"
                    class="repairTrace-details-steps-item-icon steps-item-icon-warning"
                  >
                    {{ index + 1 }}
                  </div>
                  <div v-else class="repairTrace-details-steps-item-icon">
                    {{ index + 1 }}
                  </div>
                  <div v-if="index + 1 < repairDetails.progress.length">
                    <div
                      v-if="index + 1 > current || index + 1 === current"
                      class="repairTrace-details-steps-item-line steps-item-successLine"
                    ></div>
                    <div
                      v-else
                      class="repairTrace-details-steps-item-line"
                    ></div>
                  </div>
                </div>
                <div class="repairTrace-details-steps-item-right">
                  <p
                    v-if="index + 1 > current"
                    class="font-format-medium steps-item-success"
                  >
                    {{ item.desc }}
                  </p>
                  <p
                    v-else-if="index + 1 === current"
                    class="font-format-medium steps-item-icon-warning"
                  >
                    {{ item.desc }}
                  </p>
                  <p v-else type="info" class="font-format-medium">
                    {{ item.desc }}
                  </p>
                  <p type="info" class="font-format-small">
                    {{ item.createdAt }}
                  </p>
                </div> -->
                <div class="repairTrace-details-steps-item-left">
                  <i
                    v-if="index + 1 < current || index + 1 === current"
                    class="el-icon-circle-check"
                  ></i>
                  <div
                    v-else-if="index + 1 === current + 1"
                    class="repairTrace-details-steps-item-icon steps-item-icon-warning"
                  >
                    {{ index + 1 }}
                  </div>
                  <div v-else class="repairTrace-details-steps-item-icon">
                    {{ index + 1 }}
                  </div>
                  <div v-if="index + 1 < repairDetails.progress.length">
                    <div
                      v-if="index + 1 < current || index + 1 === current"
                      class="repairTrace-details-steps-item-line steps-item-successLine"
                    ></div>
                    <div
                      v-else
                      class="repairTrace-details-steps-item-line"
                    ></div>
                  </div>
                </div>
                <div class="repairTrace-details-steps-item-right">
                  <p
                    v-if="index + 1 < current || index + 1 === current"
                    class="font-format-medium steps-item-success"
                  >
                    {{ item.desc }}
                  </p>
                  <p
                    v-else-if="index + 1 === current + 1"
                    class="font-format-medium steps-item-icon-warning"
                  >
                    {{ item.desc }}
                  </p>
                  <p v-else type="info" class="font-format-medium">
                    {{ item.desc }}
                  </p>
                  <p type="info" class="font-format-small">
                    {{ item.createdAt }}
                  </p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="微信支付"
      :visible.sync="showWeChatPay"
      center
      destroy-on-close
      @open="openPay"
      @close="closePay"
    >
      <div style="text-align: center">
        <canvas id="canvas"></canvas>
      </div>
      <span slot="footer">
        <el-button @click="showWeChatPay = false">未支付</el-button>
        <el-button type="primary" @click="showWeChatPay = false"
          >已支付</el-button
        >
      </span>
    </el-dialog>

    <!-- 附件预览 -->
    <el-image
      v-show="false"
      ref="elImage"
      :preview-src-list="srcList"
    ></el-image>
    <div class="video-component" v-if="showVideo" @click="closeVideo()">
      <div class="video-close-btn" @click.stop="closeVideo()">
        <i class="el-icon-close"></i>
      </div>
      <video controls @click.stop class="video-main">
        <source :src="videoSrc" />
      </video>
    </div>
    <!--  -->
  </div>
</template>

<script>
import PayPal from "@/components/paypal.vue";
export default {
  components: {
    PayPal,
  },
  computed: {},
  data() {
    return {
      isWeixin: false,
      isMobile: false,
      partsOpts: [],
      current: 1,
      repairDetails: {},
      showWeChatPay: false,
      code_url: "",
      expressOpts: [
        {
          label: "京东",
          value: "jd",
        },
        {
          label: "德邦",
          value: "debangkuaidi",
        },
        {
          label: "顺丰",
          value: "shunfeng",
        },
        {
          label: "极兔",
          value: "jtexpress",
        },
        {
          label: "圆通",
          value: "yuantong",
        },
        {
          label: "申通",
          value: "shentong",
        },
        {
          label: "中通",
          value: "zhongtong",
        },
      ],
      srcList: [],
      videoSrc: "",
      showVideo: false,
      payOrderItem: null,
    };
  },
  methods: {
    filterExpress(val) {
      let data = this.expressOpts.find((item) => item.value === val);
      return data.label;
    },

    async getFittinglist() {
      let res = await this.$http.getFittinglist();
      this.partsOpts = res.data || [];
      return res;
    },

    setFittingsData(data) {
      if (!data.length) return;
      for (let item of data) {
        item.fittingsData = this.partsOpts.filter((ele) =>
          item.fittings.includes(ele.id)
        );
      }
    },

    async getDetails() {
      let res = await this.$http.getRepairReqDetails({
        id: this.$route.query.id,
      });
      this.repairDetails = res.data;
      this.setFittingsData(this.repairDetails.details);
      const tmpArr = this.repairDetails.progress.filter((item) => {
        return item.isActive;
      });
      this.current = tmpArr.length;
      // res.data.progress.length
      //   ? (this.current = res.data.progress.length - 1)
      //   : 1;
      return "ok";
    },

    async getOssAttachsUrl(item) {
      let ossClient = await this.getOssClient();
      item.url = ossClient.signatureUrl(item.path, { expires: 3600 });
      if (["jpeg", "jpg", "png", "bmp"].includes(item.format)) {
        this.srcList = [item.url];
        this.$refs.elImage.showViewer = true;
      } else {
        this.videoSrc = item.url;
        this.showVideo = true;
      }
    },

    closeVideo() {
      this.showVideo = false;
      this.videoSrc = "";
    },

    async getOssClient() {
      try {
        let res = await this.$http.getSts();
        let region = "oss-cn-shenzhen";
        let bucket = "onyx-work-order";
        let client = new OSS({
          region,
          bucket,
          accessKeyId: res.data.accessKeyId,
          accessKeySecret: res.data.accessKeySecret,
          stsToken: res.data.securityToken,
        });
        return client;
      } catch (error) {
        throw new Error(error);
      }
    },

    filterUserAgent() {
      var ua = navigator.userAgent.toLowerCase();
      this.isWeixin = ua.indexOf("micromessenger") != -1;
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },

    getWXcode() {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3100b77d43964532&redirect_uri=${window.location.href}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
    },

    async getWechatOpenId() {
      try {
        let code = this.$route.query.code;
        let res = await this.$http.getWechatOpenId({ code });
        this.$local.set("oId", res.data);
        this.wxBrowserPay(res.data);
      } catch (error) {
        this.$message({
          message: `获取openId错误, ${error}`,
          type: "error",
        });
      }
    },

    async wxBrowserPay(openid) {
      let params = {
        trade_type: "JSApi",
        openid,
        fin_repair_bill_id: this.payOrderItem.repair.bill.id.toString(),
        description: this.repairDetails.code,
        amount: this.payOrderItem.repair.bill.actualAmount,
        phone: this.repairDetails.phone || this.repairDetails.receivePhone,
      };
      let res = await this.$http.orderPay(params);

      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
        }
      } else {
        this.onBridgeReady(res.data);
      }
    },

    onBridgeReady(params) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: params.appId, //公众号名称，由商户传入
          timeStamp: params.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: params.nonceStr, //随机串
          package: params.package,
          signType: params.signType, //微信签名方式：
          paySign: params.paySign, //微信签名
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.$router.push({
              name: "RepairTraceDetails",
              query: { id: this.$route.query.id },
            });
            console.log("支付成功");
          }
          if (res.err_msg == "get_brand_wcpay_request:fail") {
            console.log("支付失败");
          }
          if (res.err_msg == "get_brand_wcpay_request:cancel") {
            console.log("支付取消");
          }
        }
      );
    },

    async pay(item) {
      this.payOrderItem = item;
      this.filterUserAgent();

      if (this.isWeixin) {
        // 微信内置浏览器
        let openid = this.$local.get("oId");
        if (openid) {
          this.wxBrowserPay(openid);
        } else {
          this.getWXcode();
        }
        return;
      }

      let params = {
        trade_type: "",
        fin_repair_bill_id: item.repair.bill.id.toString(),
        description: this.repairDetails.code,
        amount: item.repair.bill.actualAmount,
        phone: this.repairDetails.phone || this.repairDetails.receivePhone,
      };

      if (this.isMobile) {
        // 手机浏览器
        params.trade_type = "H5";
        let res = await this.$http.orderPay(params);
        var a = document.createElement("a");
        var e = document.createEvent("MouseEvents");
        a.href = res.data.h5_url;
        e.initEvent("click", true, true);
        a.dispatchEvent(e);
      } else {
        // 网页端
        params.trade_type = "NATIVE";
        let res = await this.$http.orderPay(params);
        this.code_url = res.data.code_url;
        this.showWeChatPay = true;
      }
    },

    async openPay() {
      let QRCode = require("qrcode");
      await this.$nextTick();
      let canvas = document.getElementById("canvas");
      QRCode.toCanvas(canvas, this.code_url, function (error) {
        if (error) console.error(error);
      });
    },

    closePay() {
      this.code_url = "";
      this.getDetails();
    },

    getOrderData(item) {
      return {
        trade_type: "",
        fin_repair_bill_id: item.repair.bill.id.toString(),
        description: this.repairDetails.code,
        amount: item.repair.bill.actualAmount,
        phone: this.repairDetails.phone || this.repairDetails.receivePhone,
      };
    },
  },
  watch: {
    async $route() {
      await this.getFittinglist();
      await this.getDetails();
    },
  },
  async mounted() {
    if (this.$route.query.code && !this.$local.get("oId")) {
      this.getWechatOpenId();
    }
    await this.getFittinglist();
    await this.getDetails();
  },
};
</script>

<style lang="scss">
.repairTrace-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  > .el-dialog__wrapper {
    > .el-dialog {
      width: 330px;
    }
  }
  .repairTrace-details-header {
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
    > .el-button {
      font-size: 16px;
    }
  }
  .repairTrace-details-main {
    .repairTrace-details-main-item + .repairTrace-details-main-item {
      border-top: 1px dashed #eee;
    }
    .repairTrace-details-main-row {
      padding: 10px 0;
      .repairTrace-details-main-left {
        margin-right: 60px;
        > p + p {
          margin-top: 10px;
        }
      }
      .repairTrace-details-main-right {
        .repairTrace-details-main-rowItem + .repairTrace-details-main-rowItem {
          border-top: 1px dashed #eee;
        }
        .repairTrace-details-main-rowItem:first-child {
          padding: 0 0 10px;
        }
        .repairTrace-details-main-rowItem {
          padding: 10px 0;
          .repairTrace-details-main-rowItem-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .repairTrace-details-main-rowItem-left {
            > p + p {
              margin-top: 10px;
            }
          }
          .repairTrace-details-main-rowItem-bottom {
            margin-top: 10px;
            .repairTrace-details-repair-attachs {
              margin-top: 12px;
              > p {
              }
            }
          }
        }

        .repairTrace-details-main-parts {
          margin-top: 20px;
        }
        .repairTrace-details-main-tips {
          margin-top: 20px;
        }
      }
    }

    .repairTrace-details-steps {
      display: flex;
      flex-direction: column;

      .repairTrace-details-steps-item {
        display: flex;

        // align-items: center;
        .repairTrace-details-steps-item-right {
          padding: 0 10px;
        }

        .repairTrace-details-steps-item-left {
          display: flex;
          flex-direction: column;
          align-items: center;
          > i {
            font-size: 24px;
            /* font-weight: 400; */
            color: #5ac725;
          }
          .repairTrace-details-steps-item-icon {
            width: 22px;
            height: 22px;
            border-radius: 100px;
            border: 2px solid #c4c6c9;
            /* text-align: center; */
            /* line-height: 22px; */
            display: flex;
            justify-content: center;
            align-items: center;
            color: #c4c6c9;
            margin: 2px 0;
          }

          .repairTrace-details-steps-item-line {
            height: 100px;
            width: 2px;
            background-color: #c4c6c9;
          }
        }
        .steps-item-successLine {
          background-color: #5ac725 !important;
        }

        .steps-item-success {
          color: #5ac725 !important;
        }

        .steps-item-icon-warning {
          border-color: #f9ae3d !important;
          color: #f9ae3d !important;
        }
      }
    }
  }

  .video-component {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba($color: #000000, $alpha: 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    > .video-close-btn {
      position: absolute;
      top: 40px;
      right: 40px;
      width: 40px;
      height: 40px;
      font-size: 24px;
      color: #fff;
      background-color: #606266;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      opacity: 0.8;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
}

@media (max-width: 1000px) {
  .repairTrace-details-main-left {
    margin-right: 20px !important;
  }
  .repairTrace-details-main-right {
    margin-top: 10px;
  }
}
@media (max-width: 700px) {
  .video-main {
    width: 90%;
    height: 250px;
  }
}
@media (max-width: 500px) {
  .repairTrace-details {
    > .el-dialog__wrapper {
      > .el-dialog {
        width: 300px;
      }
    }
  }
}
</style>
